'use client';

import { ReactNode } from 'react';
import { AppProgressBar as ProgressBar } from 'next-nprogress-bar';
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';
import { LocalizacaoProvider } from '@/context/location';
import { resolveSiteKey } from '@/lib/recaptcha';

type Props = {
  children: ReactNode;
};

export function Providers({ children }: Props) {
  const siteKey = resolveSiteKey(process.env.NEXT_PUBLIC_RECAPTCHA_SITE_KEY);

  return (
    <>
      <LocalizacaoProvider>
        <GoogleReCaptchaProvider
          reCaptchaKey={siteKey}
          scriptProps={{ defer: true }}
        >
          {children}
          <ProgressBar
            height='5px'
            color='#264EC7'
            options={{ showSpinner: false }}
            shallowRouting
          />
        </GoogleReCaptchaProvider>
      </LocalizacaoProvider>
    </>
  );
}
